var animElements = {
  init: function(root_class) {
    var s = this;

    if ( !Modernizr.mutationobserver ) return;

    if (root_class == undefined) {
      root_class = $('body').is('.modal-show') ? '.ttmodal' : null;
    }

    var scroll_obs_options = {
      root: $(root_class)[0],
      rootMargin: '0px 0px -20px 0px',
      threshold: 0
    }

    var scroll_handler = function (entries, observer) {
      var save_time = 0;
      var timer = 0;
      var i = 0;
      
      entries.forEach(entry => { 
        // 每个成员都是一个IntersectionObserverEntry对象。
        // 举例来说，如果同时有两个被观察的对象的可见性发生变化，entries数组就会有两个成员。
        // entry.boundingClientRect
        // entry.intersectionRatio
        // entry.intersectionRect
        // entry.isIntersecting
        // entry.rootBounds
        // entry.target
        // entry.time 
        // console.log(entry.target);
        if (entry.isIntersecting) {
          // console.log(entry.intersectionRatio);

          if ($(entry.target).is('.anim_group')) {
            var child_el = $(entry.target).find('.anim_item');
            child_el.each(function (i) {
              var th = $(this);
              th.data('timer', 100 * i);
              s.anim_start(th);
            });
            scroll_obs.unobserve(entry.target);
            return;
          }

          if (entry.time == save_time) {
            i++;
            timer = 100 * i;
            if ( $('#products').is('.thumb_size_xs') && $(entry.target).is('.product') ) timer = 30 * i;
          } else {
            i = 0;
            save_time = entry.time;
          }
          // console.log(entry.target + ' in');
          $(entry.target).data('timer', timer);
          s.anim_start(entry.target);
          scroll_obs.unobserve(entry.target);
          // console.log(save_time);
          // console.log(timer);
        }
      }); 
    }

    var scroll_obs = new IntersectionObserver(scroll_handler, scroll_obs_options);

    var target_class = root_class === null ? '.anim_emt:not(.in)' : root_class + ' .anim_emt:not(.in)';
    var target = document.querySelectorAll(target_class);
    target.forEach(el => { scroll_obs.unobserve(el); scroll_obs.observe(el) });

    var group_class = root_class === null ? '.anim_group:not(.in)' : root_class + ' .anim_group:not(.in)';
    var group = document.querySelectorAll(group_class);
    group.forEach(el => { scroll_obs.unobserve(el); scroll_obs.observe(el) });

    // var resize_obs = new ResizeObserver(entries => {
    //   show_emts();
    // });
    // resize_obs.observe(document.body);
  },

  anim_els: function (els) {
    var s = this;
    els.each(function (i) {
      var th = $(this);
      th.data('timer', 100 * i);
      s.anim_start(th);
    });
  },

  anim_start: function (el) {
    var _this = $(el);
    _this.addClass('in');
    var timer = _this.data('timer') || 0;
    setTimeout(function () {
      if (_this.is('.split')) animElements.animText(_this);
      else animElements.animEmt(_this);
    }, Math.round( timer ));
  },


  animEmt: function (element) {
    var emt = element;
    // if (emt.is('.visb')) console.log('has started');
    emt.addClass('start visb');
    emt.css('pointer-events', 'none');

    emt.one(tt_animation_end, function(){
      emt.removeClass('start');
      emt.css('pointer-events', '');
    });
  },

  animText: function (element) {
    var emt = element;
    
    if (emt.find('.spt').length) {
      emt.find('.spt').removeClass('start');
    } else {
      if (emt.is('.words')) emt.lettering('words').children('span').addClass('spt');
      else emt.lettering('words').children('span').lettering().children('span').addClass('spt');
    }

    var spt_el = emt.find('.spt');
    // var spd = !emt.is('.words') && spt_el.length > 30 ? 20 : 50;
    // var _time = 0;

    spt_el.each(function (i) {
      var th = $(this);
      // var delay = spd * i;
      // _time += delay;
      var delay = Math.random() * 500 + 50;

      setTimeout(function () {
        th.addClass('start');
      }, delay);
    });

    emt.addClass('visb');

    // setTimeout(function () {
    //   emt.html(emt.attr('aria-label'));
    // }, _time);
  }

}
